import { ChangeEvent } from 'react';
import styled from 'styled-components';
import i18n from '../R/string/i18n';

interface Props {
  options: {
    value: string;
    label: string;
  }[];
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
  title: string;
  value: string;
  autoComplete?: string;
}

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  &::after {
    content: '';
    position: absolute;
    top: 32%;
    right: 15px;
    width: 7px;
    height: 7px;
    border-left: 3px solid #000;
    border-bottom: 3px solid #000;
    transform: rotate(-45deg);
    transform-origin: center;
    pointer-events: none;
  }
`;

const Select = styled.select<{ isPlaceholder: boolean }>`
  display: block;
  height: 42px;
  font-size: 14px;
  color: ${({ isPlaceholder }) => (isPlaceholder ? '#999' : 'rgb(0, 0, 0)')};
  box-shadow: rgba(221, 221, 221, 0.5) 0px 0px 2px 0px;
  -webkit-appearance: none;
  border-radius: 2px;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(227, 227, 227);
  background-color: #ffffff;
  padding: 0 12px 0 12px;
  appearance: none;
  cursor: pointer;

  &:focus {
    outline: none;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(233, 30, 99, 0.3);
    border-image: initial;
  }
`;

const Selecter = ({
  options,
  className,
  title,
  onChange,
  value,
  autoComplete
}: Props) => {
  const isPlaceholder = !value;
  return (
    <Wrapper>
      <Select
        className={className}
        title={title}
        onChange={onChange}
        value={value}
        autoComplete={autoComplete}
        isPlaceholder={isPlaceholder}
      >
        <option value="">{i18n.pleaseSelect()}</option>
        {options.map(({ value, label }, index) => (
          <option key={index} value={value}>
            {label}
          </option>
        ))}
      </Select>
    </Wrapper>
  );
};

export default Selecter;
